import React, { FC } from "react";
import { Box } from "@mui/system";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarHalfIcon from '@mui/icons-material/StarHalf';

export interface StarRatingProps {
  rating: number;
}

export const StarRating: FC<StarRatingProps> = (props) => {
  const { rating } = props;

  const renderStars = () => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      const iconProps = { key: i, sx: { fontSize: '16px', color: 'rgba(249, 190, 40, 1)' } }

      if (rating >= i)
        stars.push(<StarIcon {...iconProps} />);
      else if (rating >= i - 0.5)
        stars.push(<StarHalfIcon {...iconProps} />)
      else
        stars.push(<StarBorderIcon {...iconProps} />)
    }

    return stars;
  };

  return <Box className="star-rating">{renderStars()}</Box>;
};